import React, { useContext } from 'react';
import { ToothPeriodontalItem } from '../../../../graphql/graphql';
import { ToothIssue } from '../../Enums/TootIssue.enum';
import { SetPeriodontalItemProps } from '../../Interfaces/SetPeriodontalItemProps.interface';
import DENTButton from '../../../Base/Components/DENT/DENTButton/DENTButton';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalSelectDiseases.module.scss';
import useToothPeriodontal from '../../Hooks/Tooth/Periodontal/useToothPeriodontal';
import { useDENTContext } from '../../Services/DENTContext';

const DENTModalOverviewPeriodontalSelectDiseases = () => {
	const { periodontal } = useToothPeriodontal();
	const { activePeriodontalItem } = useDENTContext();

	if (!activePeriodontalItem) {
		return <></>;
	}

	const periodontalItem = periodontal.getPeriodontal[activePeriodontalItem];

	const onClick = (issue: ToothIssue) => {
		const currentItem = periodontal[activePeriodontalItem];
		const currentItemData =
			currentItem.getPeriodontalItem as ToothPeriodontalItem;

		currentItem.setPeriodontalItem({
			...currentItemData,
			[issue]: !currentItemData[issue],
		});
	};

	return (
		<div className={styles.wrapper}>
			<DENTButton
				title={'patientTreatment.meddiDENT.dentalCross.periodontal.bleeding'}
				onClick={() => onClick(ToothIssue.BLEEDING)}
				isSelected={!!periodontalItem?.bleeding}
			/>
			<DENTButton
				title={'patientTreatment.meddiDENT.dentalCross.periodontal.plaque'}
				onClick={() => onClick(ToothIssue.PLAQUE)}
				isSelected={!!periodontalItem?.plaque}
			/>
			<DENTButton
				title={'patientTreatment.meddiDENT.dentalCross.periodontal.pus'}
				onClick={() => onClick(ToothIssue.PUS)}
				isSelected={!!periodontalItem?.pus}
			/>
			<DENTButton
				title={'patientTreatment.meddiDENT.dentalCross.periodontal.tartar'}
				onClick={() => onClick(ToothIssue.TARTAR)}
				isSelected={!!periodontalItem?.tartar}
			/>
		</div>
	);
};

export default DENTModalOverviewPeriodontalSelectDiseases;
